<template>
  <div>
    <b-navbar id="header" type="light" variant="light" sticky>
      <b-navbar-nav class="">
        <h4 class="mb-0">Зарплатная сводная ведомость</h4>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-row>
          <b-col cols="auto">
            <b-btn size="sm" variant="info" @click="onExport()">
              <font-awesome-icon icon="file-download"/>
              Экспорт
            </b-btn>
          </b-col>
        </b-row>
      </b-navbar-nav>
    </b-navbar>

    <b-navbar id="filters">
      <b-navbar-nav>
        <b-form inline @submit.prevent="onSearch()">
          <month-picker
            class="mb-1 mr-2"
            v-model="filters.period"
            label="Период"
            placeholder="Выберите период"
            :min-year="2025"
            :clearable = false
          />

          <organization-select
            id="input-organization-select"
            ref="organization_select"
            class="mb-1 mr-2"
            :value="filters.org_id"
            @onSelect="onSelectOrganization"
          />

          <department-select
            class="mb-1 mr-2"
            id="input-department-select"
            ref="department_select"
            :value="filters.department_id"
            @onSelect="onSelectDepartment"/>

          <b-button
            class="mb-1 mr-1"
            size="sm"
            variant="outline-success"
            type="submit"
          >
            Применить
          </b-button>
        </b-form>
      </b-navbar-nav>
    </b-navbar>

    <b-table
      id="salary-summary"
      ref="salary_summary"
      class="mb-0 text-small"
      selectable
      select-mode="single"
      selectedVariant="success"
      striped
      small
      responsive
      bordered
      show-empty
      :empty-text="$t('message.common.emptyTable')"
      :busy="isBusy"
      :items="items"
      :fields="fields"
      no-provider-filtering
      no-provider-paging
      no-provider-sorting
      sticky-header
      head-variant="light"
      :foot-clone="true"
      no-footer-sorting
      tfoot-class="thead-light"
    >
      <template #table-busy>
        <div class="text-center text-success my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Загрузка</strong>
        </div>
      </template>
      <template #cell(accrual_staff_1_2)="row">
        {{ priceFormat(getAccrual_staff_1_2_salary(row.item)) }}
      </template>
      <template #cell(accrual_staff_5_6)="row">
        {{ priceFormat(getAccrual_staff_5_6(row.item)) }}
      </template>
      <template #cell(accrual_staff_sum)="row">
        {{ priceFormat(getAccrual_staff_sum(row.item)) }}
      </template>
      <template #cell(salary_staff_1)="row">
        {{ priceFormat(getSalary_staff_1(row.item)) }}
      </template>
      <template #cell(salary_staff_2)="row">
        {{ priceFormat(getSalary_staff_2(row.item)) }}
      </template>
      <template #cell(salary_staff_5_6)="row">
        {{ priceFormat(getSalary_staff_5_6(row.item)) }}
      </template>
      <template #cell(salary_staff_sum)="row">
        {{ priceFormat(getSalary_staff_sum(row.item)) }}
      </template>

      <template #foot()="row">
        {{ price(calculateTotal(row.field)) }}
      </template>
    </b-table>

    <b-card-footer id="footer" footer-bg-variant="light">
      <b-row align-h="between" align-v="center">
        <b-col cols="auto" class="mr-auto">
          Записей: <b>{{totalRows}}</b>
        </b-col>
      </b-row>
    </b-card-footer>
  </div>
</template>

<script>
import salaries from "../../network/salaries";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
  import * as XLSX from "xlsx";
    import MonthPicker from "../MonthPicker/MonthPicker";
    import OrganizationSelect from "../Organizations/OrganizationSelect";
    import DepartmentSelect from "../Catalogs/Departments/DepartmentSelect";

export default {
  name: "SalarySummary",
  components: { MonthPicker, OrganizationSelect, DepartmentSelect },
  mixins: [
    salaries,
    helpers, dateFormatter
  ],
  data() {
    return {
      items: [],
      fields: [
        {
          key: 'staff_name',
          label: "ФИО",
          class: 'salary-summary-staff-name',
          sortable: false,
        },
        {
          key: 'job_title_name',
          label: "Должность",
          sortable: false,
          class: 'salary-summary-job-title-name',
        },
        {
          key: 'start_saldo',
          label: "Сальдо на начало месяца",
          sortable: false,
          class: 'salary-summary-start-saldo',
          formatter: 'priceFormat',
          hasTotal: true,
        },
        {
          key: 'contract_salary',
          label: "Сумма ЗП факт/оклад",
          sortable: false,
          class: 'salary-summary-contract-salary',
          formatter: 'priceFormat',
          hasTotal: true,
        },
        {
          key: 'accrual_staff_1_2',
          label: "По окладу",
          sortable: false,
          class: 'salary-summary-accrual-staff',
          formatter: 'priceFormat',
          hasTotal: true,
        },
        {
          key: 'accrual_staff_5_6',
          label: "ЗП сдельно",
          sortable: false,
          class: 'salary-summary-accrual-staff',
          formatter: 'priceFormat',
          hasTotal: true,
        },
        {
          key: 'accrual_staff_sum',
          label: "Итого начисленно за месяц",
          sortable: false,
          class: 'salary-summary-accrual-staff',
          formatter: 'priceFormat',
          hasTotal: true,
        },
        {
          key: 'salary_staff_1',
          label: "По окладу/офиц Аванс",
          sortable: false,
          class: 'salary-summary-salary-staff',
          formatter: 'priceFormat',
          hasTotal: true,
        },
        {
          key: 'salary_staff_2',
          label: "По окладу/офиц ЗП",
          sortable: false,
          class: 'salary-summary-salary-staff',
          formatter: 'priceFormat',
          hasTotal: true,
        },
        {
          key: 'salary_staff_5_6',
          label: "По окладу/не офиц",
          sortable: false,
          class: 'salary-summary-salary-staff',
          formatter: 'priceFormat',
          hasTotal: true,
        },
        {
          key: 'salary_staff_sum',
          label: "Итого выплачено",
          sortable: false,
          class: 'salary-summary-salary-staff-sum',
          formatter: 'priceFormat',
          hasTotal: true,
        },
        {
          key: 'end_saldo',
          label: "Сальдо на конец месяца",
          sortable: false,
          class: 'salary-summary-end-saldo',
          formatter: 'priceFormat',
          hasTotal: true,
        },
      ],
      isBusy: false,
      totalRows: 0,
      filters: {
        query: '',
        period: this.newPeriodDate(),
        org_id: 0,
        department_id: 0,
      },
    }
  },
  async created() {
    if (this.$route.query) {
      if (this.$route.query.query) {
        this.filters.query = this.$route.query.query;
      }

      if (this.$route.query.period) {
        this.filters.period = this.dateFromServerString(this.$route.query.period);
      }

      if (this.$route.query.org_id > 0) {
        this.filters.org_id = this.$route.query.org_id;
      }

      if (this.$route.query.department_id > 0) {
        this.filters.department_id = this.$route.query.department_id;
      }
    }

    await this.getItems();
  },
  async mounted() {
    await this.configureRefs();
  },
  methods: {
    async getItems() {
      const data = {
        page: this.currentPage,
        size: this.perPage,
      }

      if (this.filters.period != null) {
        data.period = this.formatDateOnly(this.filters.period);
      }

      if (this.filters.org_id > 0) {
        data.org_id = this.filters.org_id;
      }

      if (this.filters.department_id > 0) {
        data.department_id = this.filters.department_id;
      }

      this.isBusy = true;
      const result = await this.getAccrualSalarySummary(data);
      this.isBusy = false;
      if (result.data == null) {
        this.items = [];
        this.totalRows = 0;
        const mess = "Что-то пошло не так. Попробуйте обновить страницу и повторить действие."
        this.showError(mess);
        return;
      }

      this.items = result.data;
      this.totalRows = result.data.length;
    },
    calculateTotal(field) {
      if (!field.hasTotal) { return null; }

      let totals = [];
      switch (field.key) {
        case 'accrual_staff_1_2':
          totals = this.items.map(obj => this.getAccrual_staff_1_2_salary(obj));
          break;
        case 'accrual_staff_5_6':
          totals = this.items.map(obj => this.getAccrual_staff_5_6(obj));
          break;
        case 'accrual_staff_sum':
          totals = this.items.map(obj => this.getAccrual_staff_sum(obj));
          break;
        case 'salary_staff_1':
          totals = this.items.map(obj => this.getSalary_staff_1(obj));
          break;
        case 'salary_staff_2':
          totals = this.items.map(obj => this.getSalary_staff_2(obj));
          break;
        case 'salary_staff_5_6':
          totals = this.items.map(obj => this.getSalary_staff_5_6(obj));
          break;
        case 'salary_staff_sum':
          totals = this.items.map(obj => this.getSalary_staff_sum(obj));
          break;
        default:
          totals = this.items.map(obj => obj[field.key])
      }

      return totals.reduce((acc, current) => acc + current, 0);

    },
    price(value) {
      if (value == null) { return value; }
      if (!this.isCustomNumber(value)) { return value; }
      return this.priceFormat(value, false);
    },
    // Search
    onSearch() {
      this.currentPage = 1;

      let path = {
        path: 'salary_summary',
        query: {}
      }

      if (!this.isEmpty(this.filters.query)) {
        path.query.query = this.filters.query;
      }

      if (this.filters.period != null) {
        const period = this.formatDateOnly(this.filters.period);
        if (!this.isEmpty(period)) {
          path.query.period = period;
        }
      }

      if (this.filters.org_id > 0) {
        path.query.org_id = this.filters.org_id;
      }

      if (this.filters.department_id > 0) {
        path.query.department_id = this.filters.department_id;
      }

      this.$router.push(path).catch(()=>{});

      this.getItems();
    },
    async configureRefs() {
      if (this.$refs.organization_select != null) {
        await this.$refs.organization_select.configure(this.filters.org_id);
      }

      if (this.$refs.department_select != null) {
        await this.$refs.department_select.configure(this.filters.department_id);
      }
    },
    onSelectOrganization(id) {
      this.filters.org_id = id;
    },
    onSelectDepartment(department) {
      if (department == null) {
        this.filters.department_id = 0;
        return;
      }
      this.filters.department_id = department.id;
    },
    async onExport() {
      await this.exportSummary(this.items);
    },
    // По окладу начислено без налогов. TODO: Уточнить нужно ли в отчёте
    getAccrual_staff_1_2(item) {
      let amount = 0;
      const amount1 = item.accrual_staff1 && item.accrual_staff1.amount;
      const amount2 = item.accrual_staff2 && item.accrual_staff2.amount;
      if (amount1) {
        amount = amount1;
      }
      if (amount2) {
        amount = amount + amount2;
      }
      return amount;
    },
    // По окладу выплачено без налогов
    getAccrual_staff_1_2_salary(item) {
      let amount = 0;
      const amount1 = item.salary_staff1 && item.salary_staff1.amount;
      const amount2 = item.salary_staff2 && item.salary_staff2.amount;
      if (amount1) {
        amount = amount1;
      }
      if (amount2) {
        amount = amount + amount2;
      }
      return amount;
    },
    getAccrual_staff_5_6(item) {
      let amount = 0;
      const amount5 = item.accrual_staff5 && item.accrual_staff5.amount;
      const amount6 = item.accrual_staff6 && item.accrual_staff6.amount;
      if (amount5) {
        amount = amount5;
      }
      if (amount6) {
        amount = amount + amount6;
      }
      return amount;
    },
    getAccrual_staff_sum(item) {
      let amount = 0;
      const amount1 = item.accrual_staff1 && item.accrual_staff1.amount;
      const amount2 = item.accrual_staff2 && item.accrual_staff2.amount;
      const amount5 = item.accrual_staff5 && item.accrual_staff5.amount;
      const amount6 = item.accrual_staff6 && item.accrual_staff6.amount;
      if (amount1) {
        amount = amount1;
      }
      if (amount2) {
        amount = amount + amount2;
      }
      if (amount5) {
        amount = amount + amount5;
      }
      if (amount6) {
        amount = amount + amount6;
      }
      return amount;
    },
    getSalary_staff_1(item) {
      let amount = 0;
      const amount1 = item.salary_staff1 && item.salary_staff1.amount;
      if (amount1) {
        amount = amount1;
      }
      return amount;
    },
    getSalary_staff_2(item) {
      let amount = 0;
      const amount2 = item.salary_staff2 && item.salary_staff2.amount;
      if (amount2) {
        amount = amount2;
      }
      return amount;
    },
    getSalary_staff_5_6(item) {
      let amount = 0;
      const amount5 = item.salary_staff5 && item.salary_staff5.amount;
      const amount6 = item.salary_staff6 && item.salary_staff6.amount;
      if (amount5) {
        amount = amount5;
      }
      if (amount6) {
        amount = amount + amount6;
      }
      return amount;
    },
    getSalary_staff_sum(item) {
      let amount = 0;
      const amount1 = item.salary_staff1 && item.salary_staff1.amount;
      const amount2 = item.salary_staff2 && item.salary_staff2.amount;
      const amount5 = item.salary_staff5 && item.salary_staff5.amount;
      const amount6 = item.salary_staff6 && item.salary_staff6.amount;
      if (amount1) {
        amount = amount1;
      }
      if (amount2) {
        amount = amount + amount2;
      }
      if (amount5) {
        amount = amount + amount5;
      }
      if (amount6) {
        amount = amount + amount6;
      }
      return amount;
    },
    async exportSummary(exportData) {
      const configInvoicesExport = (item) => ({
        "ФИО": () => item.staff_name || '',
        "Должность": () => item.job_title_name || '',
        "Сальдо на начало месяца": () => {
          const amount = item.start_saldo;
          if (amount) {
            return this.priceFormat(amount);
          }
          return 0;
        },
        "Сумма ЗП факт/оклад": () => {
          const amount = item.contract_salary;
          if (amount) {
            return this.priceFormat(amount);
          }
          return 0;
        },
        "По окладу": () => this.priceFormat(this.getAccrual_staff_1_2_salary(item)),
        "ЗП сдельно": () => this.priceFormat(this.getAccrual_staff_5_6(item)),
        "Итого начисленно за месяц": () => this.priceFormat(this.getAccrual_staff_sum(item)),
        "По окладу/офиц Аванс": () => this.priceFormat(this.getSalary_staff_1(item)),
        "По окладу/офиц ЗП": () => this.priceFormat(this.getSalary_staff_2(item)),
        "По окладу/не офиц": () => this.priceFormat(this.getSalary_staff_5_6(item)),
        "Итого выплачено": () => this.priceFormat(this.getSalary_staff_sum(item)),
        "Сальдо на конец месяца": () => {
          const amount = item.end_saldo;
          if (amount) {
            return this.priceFormat(amount);
          }
          return 0;
        },
      });

      const data = exportData.map(item => {
        const invoicesExport = configInvoicesExport(item);
        const excelData = {};

        for (const key in invoicesExport) {
          if (invoicesExport.hasOwnProperty(key)) {
            excelData[key] = invoicesExport[key]();
          }
        }
        return excelData;
      });

      let WS = XLSX.utils.json_to_sheet(data);
      let book = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(book, WS, 'Summary');
      XLSX.writeFile(book, 'Summary.xlsx');
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SalarySummary/SalarySummary.vue